import React from "react";
import { isMobile } from "../../../../Constants";
import classes from "../../TrucksAvailable.module.css";
import { BID_STATUS } from "../../negotiationConstants";
import ShowNegotiation from "./ShowNegotiation";

/**
 * Renders the status of a transporter based on their rate list and status. It also provides
 * buttons for accepting, rejecting, or giving a counter offer, as well as remarks.
 *
 * @param {Object} props
 * @param {Object} props.transporter - The transporter object containing rate and status information.
 * @param {number} props.index - The index of the transporter in the list.
 * @returns {JSX.Element|null} The rendered UI component for displaying transporter status or null if no status is applicable.
 */
const GetStatus = ({
  transporter,
  index,
  approval_type,
  isNegotiateAfterNoRegret,
  isRestricted,
  isEnquiryApproved,
  itemdisable,
  isExpiredAcceptanceBlocked,
  item,
  isIndentCreated,
  acceptrejectHandler,
  isApprover,
  companySettingData,
  clickHandler,
  isMandatoryApprovalRemark,
  remarkDisable,
  handleInputChange,
  interestedlist,
  isPostExpiryAcceptanceFlow,
  editnegrate,
  inputChangeHandler,
  addHandler,
  substractHandler,
  submitNegotiatedRate,
  cancelnegotiate,
}) => {
  return transporter.rate_list && transporter.rate_list.length > 0 ? (
    transporter.main_status === BID_STATUS.APPROVED ||
      (transporter.rate_list[transporter.rate_list.length - 1].main_status &&
        transporter.rate_list[transporter.rate_list.length - 1].main_status ===
        BID_STATUS.APPROVED) ||
      transporter.rate_list[transporter.rate_list.length - 1].bid_status ===
      BID_STATUS.APPROVED ? (
      <span style={{ color: "#54a63a" }}>
        <i className="fa fa-certificate" /> Approved
      </span>
    ) : (transporter.main_status === BID_STATUS.APPROVAL_PENDING ||
      (transporter.rate_list[transporter.rate_list.length - 1]
        .main_status &&
        transporter.rate_list[transporter.rate_list.length - 1]
          .main_status === BID_STATUS.APPROVAL_PENDING)) &&
      approval_type !== "bulk" &&
      transporter.rate_list[transporter.rate_list.length - 1].bid_status !==
      BID_STATUS.NEGOTIATED ? (
      <>
        {isApprover ? (
          <>
            <button
              className={"btn btn-sm btn-success"}
              style={{
                margin: isMobile() ? "0 1%" : "1% 5%",
                padding: isMobile() ? "" : "2% 4%",
                borderRadius: isMobile() ? "" : "50%",
                cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
              }}
              title="Approve"
              disabled={
                itemdisable ||
                isExpiredAcceptanceBlocked ||
                item.status?.enquiry_closed === true ||
                item.indent_created === true ||
                isIndentCreated ||
                isRestricted
              }
              onClick={(e) => acceptrejectHandler(transporter, BID_STATUS.ACCEPTED)}
            >
              {isMobile() ? "Approve" : <i className={`fa fa-thumbs-up ${classes["thumb-color"]}`}></i>}
            </button>
            {!isPostExpiryAcceptanceFlow && (
              <button
                className={"btn btn-sm btn-danger"}
                style={{
                  margin: isMobile() ? "0 1%" : "1% 5%",
                  padding: isMobile() ? "" : "2% 5%",
                  borderRadius: isMobile() ? "" : "50%",
                  cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                  opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
                }}
                title="Reject"
                disabled={
                  itemdisable ||
                  item.status?.enquiry_closed === true ||
                  item.indent_created === true ||
                  isIndentCreated ||
                  isRestricted
                }
                onClick={(e) => acceptrejectHandler(transporter, BID_STATUS.REJECTED)}
              >
                {isMobile() ? "Reject" : <i className="fa fa-times" />}
              </button>
            )}
          </>
        ) : (
          <span style={{ color: "orange" }}>Approval Pending</span>
        )}
        <br />
        {transporter.rate_list[transporter.rate_list.length - 1].remark ? (
          <span style={{ fontStyle: "italic", fontSize: "12px" }}>
            Remark:{" "}
            {transporter.rate_list[transporter.rate_list.length - 1].remark}
          </span>
        ) : null}
        {isApprover && (isMandatoryApprovalRemark || index !== 0) ? (
          <input
            disabled={(remarkDisable === true && index === 0) || isEnquiryApproved}
            type="textarea"
            onChange={(e) => handleInputChange(e, transporter, index)}
            defaultValue={interestedlist[index].remark ? interestedlist[index].remark : ""}
            placeholder={isMandatoryApprovalRemark && index !== 0 ? "Remark is mandatory*" : "Add your remark!"}
            style={{
              marginBottom: "4%",
              marginTop: "2%",
              borderColor: isMandatoryApprovalRemark && index !== 0 ? "#e74a3b" : undefined,
            }}
          />
        ) : null}
      </>
    ) : transporter.rate_list[transporter.rate_list.length - 1].bid_status ===
      BID_STATUS.ACCEPTED ? (
      <>
        {transporter.rate_list[transporter.rate_list.length - 1].main_status === BID_STATUS.ACCEPTED ? (
          <span style={{ color: "#54a63a" }}>Accepted</span>
        ) : isApprover ? (
          <>
            <button
              className={"btn btn-sm btn-success"}
              style={{
                margin: isMobile() ? "0 1%" : "1% 5%",
                padding: isMobile() ? "" : "2% 4%",
                borderRadius: isMobile() ? "" : "50%",
                cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
              }}
              title="Approve"
              disabled={
                itemdisable ||
                isExpiredAcceptanceBlocked ||
                item.status?.enquiry_closed === true ||
                item.indent_created === true ||
                isIndentCreated ||
                isRestricted
              }
              onClick={(e) => acceptrejectHandler(transporter, BID_STATUS.ACCEPTED)}
            >
              {isMobile() ? "Approve" : <i className={`fa fa-thumbs-up ${classes["thumb-color"]}`}></i>}
            </button>
            {!isPostExpiryAcceptanceFlow && (
              <button
                className={"btn btn-sm btn-danger"}
                style={{
                  margin: isMobile() ? "0 1%" : "1% 5%",
                  padding: isMobile() ? "" : "2% 5%",
                  borderRadius: isMobile() ? "" : "50%",
                  cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                  opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
                }}
                title="Reject"
                disabled={
                  itemdisable ||
                  item.status?.enquiry_closed === true ||
                  item.indent_created === true ||
                  isIndentCreated ||
                  isRestricted
                }
                onClick={(e) => acceptrejectHandler(transporter, BID_STATUS.REJECTED)}
              >
                {isMobile() ? "Reject" : <i className="fa fa-times" />}
              </button>
            )}
          </>
        ) : (
          <span style={{ color: "orange" }}>Approval Pending</span>
        )}
        <br />
        {transporter.rate_list[transporter.rate_list.length - 1].remark ? (
          <span style={{ fontStyle: "italic", fontSize: "12px" }}>
            Remark:{" "}
            {transporter.rate_list[transporter.rate_list.length - 1].remark}
          </span>
        ) : null}
        {isApprover && transporter.rate_list[transporter.rate_list.length - 1].main_status !== BID_STATUS.ACCEPTED && (isMandatoryApprovalRemark || index !== 0) ? (
          <input
            disabled={(remarkDisable === true && index === 0) || isEnquiryApproved}
            type="textarea"
            onChange={(e) => handleInputChange(e, transporter, index)}
            defaultValue={interestedlist[index].remark ? interestedlist[index].remark : ""}
            placeholder={isMandatoryApprovalRemark && index !== 0 ? "Remark is mandatory*" : "Add your remark!"}
            style={{
              marginBottom: "4%",
              marginTop: "2%",
              borderColor: isMandatoryApprovalRemark && index !== 0 ? "#e74a3b" : undefined,
            }}
          />
        ) : null}
      </>
    ) : transporter.rate_list[transporter.rate_list.length - 1].bid_status ===
      BID_STATUS.REJECTED ? (
      <>
        <span style={{ color: "red" }}>Rejected</span>
        <br />
        {transporter.rate_list[transporter.rate_list.length - 1].remark ? (
          <span style={{ fontStyle: "italic", fontSize: "12px" }}>
            Remark:{" "}
            {transporter.rate_list[transporter.rate_list.length - 1].remark}
          </span>
        ) : null}
      </>
    ) : transporter.rate_list[transporter.rate_list.length - 1].bid_status ===
      BID_STATUS.NEGOTIATED ? (
      <ShowNegotiation
        transporter={transporter}
        index={index}
        isRestricted={isRestricted}
        isEnquiryApproved={isEnquiryApproved}
        item={item}
        editnegrate={editnegrate}
        inputChangeHandler={inputChangeHandler}
        addHandler={addHandler}
        substractHandler={substractHandler}
        submitNegotiatedRate={submitNegotiatedRate}
        cancelnegotiate={cancelnegotiate}
      />
    ) : (
      <>
        {transporter.rate_list[transporter.rate_list.length - 1].transporter_accepted === true ? (
          <>
            {isNegotiateAfterNoRegret === true ? (
              // Full set: Accept + Reject + Counter Offer
              <>
                <button
                  className={"btn btn-sm btn-success"}
                  style={{
                    margin: isMobile() ? "0 1%" : "1% 5%",
                    padding: isMobile() ? "" : "2% 4%",
                    borderRadius: isMobile() ? "" : "50%",
                    cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                    opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
                  }}
                  title="Accept"
                  disabled={
                    itemdisable ||
                    isExpiredAcceptanceBlocked ||
                    item.status?.enquiry_closed === true ||
                    item.indent_created === true ||
                    isIndentCreated ||
                    isRestricted
                  }
                  onClick={(e) => acceptrejectHandler(transporter, BID_STATUS.ACCEPTED)}
                >
                  {isMobile() ? "Accept" : !isApprover ? (
                    <i className="fa fa-check" />
                  ) : (
                    <i className={`fa fa-thumbs-up ${classes["thumb-color"]}`}></i>
                  )}
                </button>
                {!isPostExpiryAcceptanceFlow && (
                  <button
                    className={"btn btn-sm btn-danger"}
                    style={{
                      margin: isMobile() ? "0 1%" : "1% 5%",
                      padding: isMobile() ? "" : "2% 5%",
                      borderRadius: isMobile() ? "" : "50%",
                      cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                      opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
                    }}
                    title="Reject"
                    disabled={
                      itemdisable ||
                      item.status?.enquiry_closed === true ||
                      item.indent_created === true ||
                      isIndentCreated ||
                      isRestricted
                    }
                    onClick={(e) => acceptrejectHandler(transporter, BID_STATUS.REJECTED)}
                  >
                    {isMobile() ? "Reject" : <i className="fa fa-times" />}
                  </button>
                )}
                {!isPostExpiryAcceptanceFlow && (
                  <button
                    className={"btn btn-sm btn-primary"}
                    style={{
                      margin: isMobile() ? "0 1%" : "1% 5%",
                      padding: isMobile() ? "" : "1.5% 6%",
                      borderRadius: isMobile() ? "" : "50%",
                      cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                      opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
                    }}
                    title="Give counter offer"
                    disabled={
                      itemdisable ||
                      item.status?.enquiry_closed === true ||
                      item.indent_created === true ||
                      isIndentCreated ||
                      isRestricted
                    }
                    onClick={(e) => clickHandler(transporter)}
                  >
                    {isMobile() ? "Counter Offer" : companySettingData?.default_currency?.default_currency?.symbol ? (
                      <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                        {companySettingData?.default_currency?.default_currency?.symbol}
                      </span>
                    ) : (
                      <i className="fa fa-inr" />
                    )}
                  </button>
                )}
                <input
                  disabled={(remarkDisable === true && index === 0) || isEnquiryApproved}
                  type="textarea"
                  onChange={(e) => handleInputChange(e, transporter, index)}
                  defaultValue={interestedlist[index].remark ? interestedlist[index].remark : ""}
                  placeholder={isMandatoryApprovalRemark && index !== 0 ? "Remark is mandatory*" : "Add your remark!"}
                  style={{
                    marginBottom: "4%",
                    marginTop: "2%",
                    borderColor: isMandatoryApprovalRemark && index !== 0 ? "#e74a3b" : undefined,
                  }}
                />
              </>
            ) : (
              // Original: only Accept/Approve — NO reject, NO counter offer
              <>
                <button
                  className={"btn btn-sm btn-success"}
                  style={{
                    margin: isMobile() ? "0 1%" : "1% 5%",
                    padding: isMobile() ? "" : "2% 4%",
                    borderRadius: isMobile() ? "" : "50%",
                    cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                    opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
                  }}
                  title="Accept"
                  disabled={
                    itemdisable ||
                    isExpiredAcceptanceBlocked ||
                    item.status?.enquiry_closed === true ||
                    item.indent_created === true ||
                    isIndentCreated ||
                    isRestricted
                  }
                  onClick={(e) => acceptrejectHandler(transporter, BID_STATUS.ACCEPTED)}
                >
                  {isMobile() ? "Accept" : !isApprover ? (
                    <i className="fa fa-check" />
                  ) : (
                    <i className={`fa fa-thumbs-up ${classes["thumb-color"]}`}></i>
                  )}
                </button>
                <br />
                <span style={{ color: "#393185", fontSize: "11px", fontStyle: "italic" }}>
                  Note: {transporter.transporter_name} has Accepted your <b>Counter Offer</b>,{" "}
                  {isApprover
                    ? "Kindly click above button to Approve the rate"
                    : "Kindly click above button to request approval"}
                </span>
                <input
                  disabled={(remarkDisable === true && index === 0) || isEnquiryApproved}
                  type="textarea"
                  onChange={(e) => handleInputChange(e, transporter, index)}
                  defaultValue={interestedlist[index].remark ? interestedlist[index].remark : ""}
                  placeholder={isMandatoryApprovalRemark && index !== 0 ? "Remark is mandatory*" : "Add your remark!"}
                  style={{
                    marginBottom: "4%",
                    marginTop: "2%",
                    borderColor: isMandatoryApprovalRemark && index !== 0 ? "#e74a3b" : undefined,
                  }}
                />
              </>
            )}
          </>
        ) : (
          <>
            <button
              className={"btn btn-sm btn-success"}
              style={{
                margin: isMobile() ? "0 1%" : "1% 5%",
                padding: isMobile() ? "" : "2% 4%",
                borderRadius: isMobile() ? "" : "50%",
                cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
              }}
              title="Accept"
              disabled={
                itemdisable ||
                item.status?.enquiry_closed === true ||
                item.indent_created === true ||
                isIndentCreated ||
                isRestricted
              }
              onClick={(e) => acceptrejectHandler(transporter, BID_STATUS.ACCEPTED)}
            >
              {isMobile() ? (
                "Accept"
              ) : !isApprover ? (
                <i className="fa fa-check" />
              ) : (
                <i
                  className={`fa fa-thumbs-up ${classes["thumb-color"]}`}
                ></i>
              )}
            </button>
            {!isPostExpiryAcceptanceFlow && (
              <button
                className={"btn btn-sm btn-danger"}
                style={{
                  margin: isMobile() ? "0 1%" : "1% 5%",
                  padding: isMobile() ? "" : "2% 5%",
                  borderRadius: isMobile() ? "" : "50%",
                  cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                  opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
                }}
                title="Reject"
                disabled={
                  itemdisable ||
                  isExpiredAcceptanceBlocked ||
                  item.status?.enquiry_closed === true ||
                  item.indent_created === true ||
                  isIndentCreated ||
                  isRestricted
                }
                onClick={(e) => acceptrejectHandler(transporter, BID_STATUS.REJECTED)}
              >
                {isMobile() ? "Reject" : <i className="fa fa-times" />}
              </button>)}
            {!isPostExpiryAcceptanceFlow && (<button
              className={"btn btn-sm btn-primary"}
              style={{
                margin: isMobile() ? "0 1%" : "1% 5%",
                padding: isMobile() ? "" : "1.5% 6%",
                borderRadius: isMobile() ? "" : "50%",
                cursor: (isRestricted || isEnquiryApproved) ? "not-allowed" : "pointer",
                opacity: (isRestricted || isEnquiryApproved) ? 0.6 : 1,
              }}
              title="Give counter offer"
              disabled={
                itemdisable ||
                isExpiredAcceptanceBlocked ||
                item.status?.enquiry_closed === true ||
                item.indent_created === true ||
                isIndentCreated ||
                isRestricted
              }
              onClick={(e) => clickHandler(transporter)}
            >
              {isMobile() ? (
                "Counter Offer"
              ) : companySettingData?.default_currency?.default_currency
                ?.symbol ? (
                <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                  {
                    companySettingData?.default_currency?.default_currency
                      ?.symbol
                  }
                </span>
              ) : (
                <i className="fa fa-inr" />
              )}
            </button>)}
            {/* Remark input shown for every rank, including L1. */}
            <input
              disabled={(remarkDisable === true && index === 0) || isEnquiryApproved}
              type="textarea"
              onChange={(e) => handleInputChange(e, transporter, index)}
              defaultValue={
                interestedlist[index].remark
                  ? interestedlist[index].remark
                  : ""
              }
              placeholder={
                isMandatoryApprovalRemark && index !== 0
                  ? "Remark is mandatory*"
                  : "Add your remark!"
              }
              style={{
                marginBottom: "4%",
                marginTop: "2%",
                borderColor: isMandatoryApprovalRemark && index !== 0 ? "#e74a3b" : undefined,
              }}
            />
          </>
        )}
      </>
    )
  ) : null;
};

export default GetStatus;
